import { useState, useCallback } from 'react';
import { fetchVideoList, deleteVideo, uploadVideo } from "../tools/SystemManagement";

export const useVideoManagement = (history) => {
    const [videoLinks, setVideoLinks] = useState([]);
    const [videosProcessing, setVideosProcessing] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [uploadMouseHover, setUploadMouseHover] = useState(false);

    const populateVideoLinks = useCallback(async () => {
        try {
            setVideosProcessing(true);
            let response = await fetchVideoList();
            
            if (!response || response.status !== 200) {
                console.error('Video list fetch failed:', response);
                setErrorMessage('Failed to load videos');
                setVideosProcessing(false);
                return;
            }

            if (!response.data || !response.data.videos || !Array.isArray(response.data.videos)) {
                console.error('No videos in response:', response.data);
                setVideoLinks([]);
                setVideosProcessing(false);
                return;
            }

            setVideoLinks(response.data.videos);
            setVideosProcessing(false);
        } catch (error) {
            console.error('Error populating video links:', error);
            setErrorMessage('Error loading videos: ' + (error.message || 'Unknown error'));
            setVideosProcessing(false);
            setVideoLinks([]);
        }
    }, []);

    const handleUploadVideo = useCallback(async (file) => {
        setVideosProcessing(true);
        setErrorMessage("");
        
        let response = await uploadVideo(file);
        
        if (response.data?.redirect !== undefined) {
            history.push('/login');
            return;
        }

        if (response.status === 200) {
            await populateVideoLinks();
        } else {
            setErrorMessage(response.data);
        }
        
        setVideosProcessing(false);
    }, [history, populateVideoLinks]);

    const handleDeleteVideo = useCallback(async (videoUrl) => {
        setVideosProcessing(true);
        setErrorMessage("");
        
        let split = videoUrl.split("/");
        let videoName = split[split.length - 1];
        let response = await deleteVideo(videoName);
        
        if (response.status === 200) {
            await populateVideoLinks();
        }
        
        setVideosProcessing(false);
    }, [populateVideoLinks]);

    const handleCopyVideoLink = useCallback((videoUrl) => {
        navigator.clipboard.writeText(videoUrl);
        setSnackBarOpen(true);
    }, []);

    const handleMouseEnterUpload = useCallback(() => {
        setUploadMouseHover(true);
    }, []);

    const handleMouseLeaveUpload = useCallback(() => {
        setUploadMouseHover(false);
    }, []);

    return {
        videoLinks,
        videosProcessing,
        errorMessage,
        snackBarOpen,
        uploadMouseHover,
        
        populateVideoLinks,
        handleUploadVideo,
        handleDeleteVideo,
        handleCopyVideoLink,
        handleMouseEnterUpload,
        handleMouseLeaveUpload,
        
        setErrorMessage,
        setSnackBarOpen,
    };
};